/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetGlycerinRatingStatusFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetGlycerinRatingStatusFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { GlycerinRatingStatus } from '@packages/tracking';
import type { getGlycerinRatingStatus } from '.';

export const getGlycerinRatingStatusDataMock: GetGlycerinRatingStatusFragmentFragment = {
  product: {
    avgRating: 1.33,
    reviewCount: 1337,
  },
};

export const getGlycerinRatingStatusReturnMock: ReturnType<typeof getGlycerinRatingStatus> = {
  ratingStatus: GlycerinRatingStatus.RATED,
  rating: getGlycerinRatingStatusDataMock.product?.avgRating,
  ratingCount: getGlycerinRatingStatusDataMock.product?.reviewCount,
};

export function getGetGlycerinRatingStatusFragmentedData(
  data?: GetGlycerinRatingStatusFragmentFragment,
) {
  return makeFragmentData(
    data || getGlycerinRatingStatusDataMock,
    GetGlycerinRatingStatusFragmentFragmentDoc,
  );
}
